import { render, staticRenderFns } from "./ProductSalesForm.vue?vue&type=template&id=5ab8f185&"
import script from "./ProductSalesForm.vue?vue&type=script&lang=ts&"
export * from "./ProductSalesForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports